import { createAsyncThunk } from '@reduxjs/toolkit';
import tournamentRepository from 'modules/client/tournaments/domain/repositories/tournament.repository';
import type { Match, Player, Stage, Team } from 'modules/client/tournaments/domain/types';
import type { ChampionshipDto } from 'modules/client/tournaments/domain/types/dtos';
import calculatePlayersStats from 'modules/client/tournaments/domain/utils/calculate-players-stats';

const PREFIX = 'clientTournament';

export const fetchChampionshipInfo = createAsyncThunk<
  {
    stages: Stage[];
    players: Player[];
    teams: Team[];
    matches: Match[];
    championship: ChampionshipDto;
  },
  { championshipId: number }
>(`${PREFIX}/fetchChampionshipInfo`, async ({ championshipId }, { rejectWithValue }) => {
  try {
    const teams = await tournamentRepository.getTeams(championshipId);
    const matches = await tournamentRepository.getMatches(championshipId, teams);
    const [players, stages, championship, matchEvents] = await Promise.all([
      tournamentRepository.getPlayers(championshipId),
      tournamentRepository.getStage(championshipId, matches),
      tournamentRepository.getChampionshipInfo(championshipId),
      tournamentRepository.getMatchEvents(championshipId),
    ]);

    return {
      stages,
      players: calculatePlayersStats(players, matchEvents),
      teams,
      matches,
      championship,
    };
  } catch (error) {
    console.error(`${PREFIX}/fetchChampionshipInfo error:`, error);

    let message;
    if (error instanceof Error) {
      message = error.message;
    } else {
      message = String(error);
    }
    return rejectWithValue(message);
  }
});
